export function hasSms(tenant) {
  return tenant?.smsEnabled === true;
}

export function hasCalls(tenant) {
  return tenant?.callsEnabled === true;
}

export function hasDirectWhatsApp(tenant) {
  return tenant?.whatsappWebEnabled === true;
}

export function hasAutomation(tenant) {
  return tenant?.aiAssistantEnabled === true;
}

export function hasEmail(tenant) {
  return tenant?.emailMarketingEnabled === true;
}

export function hasInbox(tenant) {
  return hasSms(tenant) || hasDirectWhatsApp(tenant) || hasEmail(tenant);
}

export function hasCampaigns(tenant) {
  return hasSms(tenant) || hasEmail(tenant);
}

export function hasApiAccess(tenant) {
  return hasSms(tenant) || hasDirectWhatsApp(tenant) || hasAutomation(tenant) || hasEmail(tenant);
}

export function hasShortLinks(tenant) {
  return hasSms(tenant) || hasDirectWhatsApp(tenant) || hasAutomation(tenant) || hasEmail(tenant);
}
